import React from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";

function Popup({ visible, setVisible, message, onAccept, title = "" }) {
  return (
    <Modal show={visible} onHide={setVisible}>
      <Modal.Header closeButton>
        <Modal.Title
          style={{
            color: "red",
            fontFamily: "medium-pro, sans-serif",
          }}
        >
          {title}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body
        style={{
          fontFamily: "thin-pro, sans-serif",
        }}
      >
        <p className="body">{message}</p>
      </Modal.Body>

      <Modal.Footer
        style={{
          fontFamily: "medium-pro, sans-serif",
        }}
      >
        <Button variant="secondary" onClick={setVisible}>
          Close
        </Button>
        <Button
          variant="primary"
          style={{ backgroundColor: "red", borderColor: "red" }}
          onClick={onAccept}
        >
          OK
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default Popup;
